const { env } = require("./const");
const crypto = require("crypto-js");

export const encrypt = async (
  text,
  secret = env.REACT_APP_PASSWORD_MASK_SECRET
) => {
  return crypto.AES.encrypt(text, secret).toString();
};

export const decrypt = async (
  text,
  secret = env.REACT_APP_PASSWORD_MASK_SECRET
) => {
  const bytes = crypto.AES.decrypt(text, secret);
  return bytes.toString(crypto.enc.Utf8);
};

// Where a dev sign-in should land. Default stays localhost:<port> so a laptop
// checkout behaves exactly as before; the shared designer preview sets
// REACT_APP_DEV_APP_BASE (with an {app} placeholder) so the post-login redirect
// stays inside that environment instead of pointing at the reviewer's machine.
export const getDevAppLink = (link) => {
  if (!link.includes("?")) return null;
  const query = link.split("?")[1];
  const lower = link.toLowerCase();
  const app = lower.includes("institute")
    ? "institute"
    : lower.includes("student")
    ? "student"
    : lower.includes("admin")
    ? "admin"
    : "corporate";
  const base = process.env.REACT_APP_DEV_APP_BASE;
  if (base) {
    return `${base.replace("{app}", app).replace(/\/$/, "")}/signin?${query}`;
  }
  const ports = { corporate: 3001, institute: 3002, student: 3003, admin: 3004 };
  return `http://localhost:${ports[app]}/signin?${query}`;
};
